module.exports = __webpack_public_path__ + "images/header_nav/header-bg-dark.png";